import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {HttpFormService} from '../../../../services/formServices';
import {GlobalObjectService} from '../../../../class/global-obj';

export interface IFiles {
    file_category_name: string;
    file_extension: string;
    original_file_name: string;
    file_link: string;
    file_size: number;
    record_date: string;
}

@Component({
    selector: 'noos-viewfiles',
    templateUrl: './viewfiles.component.html',
    styleUrls: ['./viewfiles.component.scss']
})
@NoosFormTypeService.register('viewFiles')
export class ViewfilesComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId: 0;

    fileList: IFiles[] = [];


    constructor(private dataService: HttpFormService) {
    }

    ngOnInit() {
    }


    ngAfterViewInit(): void {
        this.recordId = GlobalObjectService.getVar('record_id_' + this.formId.toString());
        this.dataService.recordFiles(this.datasetId, this.recordId, this.prop.viewOptions.selectedItems).subscribe(ret => {
            if (ret.complete) {
                this.fileList = ret.data;
            }
        });

    }

}

